import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/core/api/api.service';
import { EXSEP_ENDPOINTS } from 'src/app/core/api/endpoints/exsep.endpoints';
import { SERVICES_ORDERS_ENDPOINTS } from 'src/app/core/api/endpoints/services-orders.endpoints';

@Injectable({
  providedIn: 'root',
})
export class ExsepService {
  private api = inject(ApiService);

  updateExsepStatusProfile(data): Observable<any> {
    return this.api.put(EXSEP_ENDPOINTS.V1.EXSEP_PROFILE_REQUEST, data);
  }

  updateSopraStatusProfile(data, id): Observable<any> {
    return this.api.put(EXSEP_ENDPOINTS.V1.SOPRA_EXPERT(id), data);
  }

  updateAyenStatusProfile(data, id): Observable<any> {
    return this.api.put(EXSEP_ENDPOINTS.V1.AYEN_EXPERT(id), data);
  }

  exsepPackages(query): Observable<any> {
    return this.api.get(EXSEP_ENDPOINTS.V1.EXSEP_PACKAGE_COSTS, {
      params: query,
    });
  }

  getInspectorShareTypes(): Observable<any> {
    return this.api.get(EXSEP_ENDPOINTS.V1.INSPECTOR_SHARE_TYPES);
  }

  getSopraProfilesByPage(query) {
    return this.api
      .get(EXSEP_ENDPOINTS.V1.SOPRA_EXPERTS, { params: query })
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }

  getAyenProfilesByPage(query) {
    return this.api
      .get(EXSEP_ENDPOINTS.V1.AYEN_EXPERTS, { params: query })
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }

  getServiceRequest(params: any): Observable<any> {
    return this.api.get(SERVICES_ORDERS_ENDPOINTS.V2.SOPRA_SERVICES_REQUEST, {
      params,
    });
  }

  getServiceRequestDetails(id: number) {
    return this.api.get(SERVICES_ORDERS_ENDPOINTS.V2.SOPRA_SERVICE_DETAILS(id));
  }

  updateServiceRequestStatus(
    id: number,
    data: { status: string; notes?: string },
  ): Observable<any> {
    return this.api.patch(
      SERVICES_ORDERS_ENDPOINTS.V2.SOPRA_SERVICE_DETAILS(id),
      data,
    );
  }
}
